export const DELETE_FAQ = "DELETE_FAQ";

export function deleteFaq(faqId) {
  return {
    type: DELETE_FAQ,
    payload: { faqId },
  };
}
